import { createAction, props } from '@ngrx/store';

import { VoucherStatus, VoucherType } from '@vi-iot/client';

export namespace VouchersActions {
  export enum Type {
    GENERATE_VOUCHER = '[VOUCHERS] Generate Voucher',
    GENERATE_VOUCHER_SUCCESS = '[VOUCHERS] Generate Voucher Success',
    GENERATE_VOUCHER_ERROR = '[VOUCHERS] Generate Voucher Error',
    VALIDATE_VOUCHER = '[VOUCHERS] Validate Voucher',
    VALIDATE_VOUCHER_SUCCESS = '[VOUCHERS] Validate Voucher Success',
    VALIDATE_VOUCHER_ERROR = '[VOUCHERS] Validate Voucher Error',
    CLEAR_STATE = '[VOUCHERS] Clear State',
  }

  export const GenerateVoucher = createAction(
    Type.GENERATE_VOUCHER,
    props<{ voucherType: VoucherType; companyNumber?: string }>()
  );

  export const GenerateVoucherSuccess = createAction(
    Type.GENERATE_VOUCHER_SUCCESS,
    props<{ voucherCode: string }>()
  );

  export const GenerateVoucherError = createAction(
    Type.GENERATE_VOUCHER_ERROR,
    props<{ error: any }>()
  );

  export const ValidateVoucher = createAction(Type.VALIDATE_VOUCHER, props<{ voucher: string }>());

  export const ValidateVoucherSuccess = createAction(
    Type.VALIDATE_VOUCHER_SUCCESS,
    props<{ status: VoucherStatus }>()
  );

  export const ValidateVoucherError = createAction(
    Type.VALIDATE_VOUCHER_ERROR,
    props<{ error: any }>()
  );

  export const ClearState = createAction(Type.CLEAR_STATE);
}
